<app-view [name]="'concept'" (search)="onSearch($event)"></app-view>

<ng-container *ngIf="ready">
  <div class="butonera-izquierda">
    <!-- Izquierda (perfecto) -->
    <button mat-stroked-button (click)="import()" class="me-2">Importar</button>
    <button mat-stroked-button (click)="export()" class="me-2">Exportar</button>
    <button mat-stroked-button (click)="sales()" class="me-2">Informe ventas</button>

    <ng-container *ngIf="exportStatus">
      <div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div>
    </ng-container>
    <app-help key='Conceptos3'></app-help>

    <mat-card appearance="outlined" class="tarjeta-coste text-center" *ngIf="readyValue">
      <mat-card-content>
        <p><span class="titulo">Coste Total:</span> <span class="valor"> {{ totalCostValue }}</span></p>
      </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined" class="tarjeta-venta text-center" *ngIf="readyValue">
      <mat-card-content>
        <p><span class="titulo">Venta Total:</span> <span class="valor"> {{ totalSalesValue }}</span></p>
      </mat-card-content>
    </mat-card>

    <!-- Spinner centrado -->
    <div class="spinner-container" *ngIf="!readyValue">
      <div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div>
      <p class="spinner-text">Cargando resumen de valores...</p>
    </div>

    <!-- DERECHA pegado al borde -->
    <button type="button" (click)="create()" mat-stroked-button
      class="btn btn-warning btn-circle btn-lg fc-black p-0 btn-create-right">
      <mat-icon class="mat-icon-add-custom">add</mat-icon>
      <app-help key='Conceptos5'></app-help>
    </button>
  </div>


  <!-- Template para campo 'units' editable -->
  <ng-template #unitsEditable let-row>
    <input type="number" [value]="row.units" (input)="onUnitsInput($event, row)" (keydown.enter)="onUnitsSubmit(row)" />
  </ng-template>

  <app-table [columns]="headerTable" [dataSource]="dataSource" [hasButton]="true" [actionsTemplate]="actionsButtons"
    [hasObservableFilter]="false" [hasFilterOldObservable]="false" [customTemplates]="{ unitsEditable: unitsEditable }"
    (nameConceptClick)="onNameConceptClick($event)" (unitsEnter)="onUnitsEnter($event)">
  </app-table>

  <div class="container-fluid">
    <div class="row">
      <div class="col-md-2 col-lg-1 col-xs-12">
        <select id="itemsPerPage" [(ngModel)]="itemsPerPage" (change)="getList()" class="form-control"
          style="margin-left: 20px;">
          <option value="5">5</option>
          <option value="10">10</option>
          <option value="20">20</option>
        </select>
      </div>
      <div class="col-md-10 col-lg-11 col-xs-12">
        <pagination (pageChanged)="pageChanged($event)" [(ngModel)]="currentPage" [totalItems]="totalItems"
          [itemsPerPage]="itemsPerPage" [maxSize]="5" previousText="Anterior" style="float: right;margin-right: 20px;"
          nextText="Siguiente"></pagination>
      </div>
    </div>
  </div>


  <ng-template #actionsButtons let-uid="uid" let-imageId="imageId" let-fileId="fileId" let-row="row">
    <ul class="custom-class">
      <li (click)="edit(uid)">
        <a>
          <mat-icon>create</mat-icon>Editar
        </a>
      </li>
      <li (click)="delete(uid)">
        <a>
          <mat-icon>warning</mat-icon>Borrar
        </a>
      </li>
      <li (click)="serialNumber(uid)">
        <a>
          <mat-icon>description</mat-icon>Número de serie
        </a>
      </li>
      <li (click)="syncBookcit(uid)">
        <a>
          <mat-icon>sync</mat-icon>Sincronizar con Bookcit
        </a>
      </li>
      <ng-container *ngIf="imageId != 0">
        <li (click)="downloadFile(imageId)">
          <a>
            <mat-icon>description</mat-icon>Ver Imagen
          </a>
        </li>
      </ng-container>
      <ng-container *ngIf="fileId != 0">

        <li (click)="downloadFile(fileId)">
          <a>
            <mat-icon>description</mat-icon>Ver Documento
          </a>
        </li>
      </ng-container>
    </ul>
  </ng-template>
</ng-container>

<ng-container *ngIf="empty">
  <div class="text-center">
    <img src="assets/icons/concepto.svg" class="invoiceImage">
    <p style="color: #9e9e9e">No tiene ningún concepto, presione + para crear uno.</p>
  </div>
</ng-container>

<ng-container *ngIf="!ready">
  <div class="container" style="height:65vh">
    <div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div>
  </div>
</ng-container>